import * as React from "react";
import { Button, Dialog, Input } from "@swivu/shared-ui";
import { cn } from "@swivu/shared-ui/src/private/utils.js";
import { usePostResourceAgendaPublicLogin } from "@swivu/client-api";
import { useLocation } from "react-router-dom";

const Login = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const {
    mutate,
    error,
    isSuccess,
    isPending: isLoading
  } = usePostResourceAgendaPublicLogin();
  const [localErrorMessage, setLocalErrorMessage] = React.useState<
    string | null
  >(null);
  const [password, setPassword] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (isSuccess && params.get("redirect")) {
      const goto = decodeURIComponent(params.get("redirect") ?? "");
      window.location.href = goto;
    }
  }, [isSuccess]);

  React.useEffect(() => {
    if (localErrorMessage) setLocalErrorMessage(null);
  }, [password, localErrorMessage]);

  React.useEffect(() => {
    if (error) {
      const [status] = error.message.split(":");
      if (status === "401") {
        setLocalErrorMessage("Incorrect password");
      } else {
        setLocalErrorMessage("Something went wrong");
      }
    }
  }, [error]);
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (password && params.get("redirect")) {
      const slug = decodeURIComponent(params.get("redirect") ?? "").split(
        "/"
      )[2];
      mutate({ password, slug });
    }
  };
  return (
    <Dialog.Root open={true} modal={true}>
      <Dialog.Content
        className="bg-card"
        hideCloseIcon={true}
        position="center"
        aria-description="Login to your account"
      >
        <div className="mx-auto flex min-h-full items-center justify-center p-4">
          <div className="mx-auto w-full">
            <div className=" w-full rounded-lg  p-8   md:max-w-xl ">
              <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-2 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-lg">
                  <img
                    className="mx-auto h-10 w-auto"
                    src="/assets/swivu-logo.svg"
                    alt="Swivu"
                  />
                  <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight ">
                    Privacy Protected
                  </h2>
                </div>
                <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                  <form
                    onSubmit={handleSubmit}
                    className="space-y-6"
                    action="#"
                    method="POST"
                  >
                    <div>
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="password"
                          className="block text-sm font-medium leading-6 "
                        >
                          Passcode
                        </label>
                        {localErrorMessage && (
                          <p className="ml-3 text-sm text-red-600">
                            {localErrorMessage}
                          </p>
                        )}
                      </div>

                      <div className="mt-2">
                        <Input
                          onChange={(e) => {
                            // if (localErrorMessage) setLocalErrorMessage(null);
                            setPassword(e.target.value);
                          }}
                          id="password"
                          name="password"
                          type="password"
                          autoComplete="current-password"
                          required
                          className={cn(
                            ``,
                            localErrorMessage &&
                              `bg-red-400/50 dark:bg-red-800/50`
                          )}
                        />
                      </div>
                    </div>

                    <div>
                      <Button
                        disabled={
                          (password && password?.length < 1) || isLoading
                        }
                        action="secondary"
                        loading={isLoading}
                        type="submit"
                        className="flex w-full justify-center rounded-md bg-indigo-500 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
                      >
                        Sign in
                      </Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default Login;
